/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CenterBoxPurchase.vue?vue&type=template&id=54f05bc5&scoped=true"
import script from "./CenterBoxPurchase.vue?vue&type=script&lang=js"
export * from "./CenterBoxPurchase.vue?vue&type=script&lang=js"
import style0 from "./CenterBoxPurchase.vue?vue&type=style&index=0&id=54f05bc5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f05bc5",
  null
  
)

export default component.exports